import {
    SET_BREADCRUMBS,
    SET_TITLE,
    TOGGLE_ASIDE,
    TOGGLE_DARK,
    SET_CREATE_BUTTON,
    SET_SEARCH_HANDLER,
    SET_SEARCH_STRING, SET_HEAD_BTNS
} from "./types";


export const toggleAside = content => ({
    type: TOGGLE_ASIDE,
    asideStatus: content
})

export const toggleDark = content => ({
    type: TOGGLE_DARK,
    darkStatus: content
})

export const setTitle = content => ({
    type: SET_TITLE,
    pageTitle: content
})

export const setBreadcrumbs = content => ({
    type: SET_BREADCRUMBS,
    breadcrumbs: content
})

export const setHeadBtns = content => ({
    type: SET_HEAD_BTNS,
    headBtns: content
})

export const setCreateButton = content => ({
    type: SET_CREATE_BUTTON,
    createButton: content
})
export const setSearchHandler = content => ({
    type: SET_SEARCH_HANDLER,
    searchHandler: content
})
export const setSearchString = content => ({
    type: SET_SEARCH_STRING,
    searchString: content
})

export const isMobile = content => ({
    type: 'isMobile',
    status: content
})